import { VersionGate } from '@frameio/shared/account-migration/VersionGate';
import { useGetActiveUserId } from '@frameio/shared/hooks/useGetActiveUserId';
import { UserTransferBatchEventsSubscription } from './transferbatch-events/UserTransferBatchEventsSubscription';

/**
 * subscribe to account-level events.
 * include this high up in your tree, like in your main app layout
 * */
export const UserSubscriptions = () => {
  const userId = useGetActiveUserId();
  return (
    <VersionGate>
      <UserTransferBatchEventsSubscription userId={userId} />
    </VersionGate>
  );
};
